
// wrapper for 202010
import React from 'react'
import { graphql } from 'gatsby'
import Page from '/Users/jason/dev/advising-survey/src/pages/report/index.js'
const props = {
  "route": "202010",
  "routes": [
    "201810",
    "201910",
    "202010",
    "202110",
    "202210",
    "202310",
    "202410",
    "202510",
    "202610"
  ],
  "tables": [
    {
      "renderer": "DemoTable",
      "i": 3,
      "code": "Q1",
      "prefix": "Q1",
      "n": 0,
      "part": null,
      "kind": "single",
      "choices": [
        "College of Arts & Sciences",
        "Culverhouse College of Commerce",
        "College of Communication & Information Sciences",
        "College of Education",
        "College of Engineering",
        "College of Human Environmental Sciences",
        "Capstone College of Nursing",
        "School of Social Work",
        "Capstone Center for Student Success",
        "I don't know"
      ],
      "multi": ",",
      "demographic": "Which college/school advised you this term?",
      "title": "Respondent Composition",
      "prompt": "Which college/school advised you this term?"
    },
    {
      "renderer": "Multi",
      "i": 4,
      "code": "Q2",
      "prefix": "Q2",
      "n": 1,
      "part": null,
      "kind": "single",
      "choices": [
        "Office of University Registrar",
        "Family Member",
        "Athletic Advisor",
        "DegreeWorks",
        "Academic Advisor",
        "Undergraduate Catalog (Web)",
        "Other Students"
      ],
      "multi": ",",
      "prompt": "Where do you get most of your academic information? (check all that apply)"
    },
    {
      "renderer": "Multi",
      "i": 5,
      "code": "Q3",
      "prefix": "Q3",
      "n": 2,
      "part": null,
      "kind": "single",
      "choices": [
        "In-person Advising Appointment",
        "Referred to DegreeWorks Worksheet or Plan",
        "Group Session",
        "Advised Via Email",
        "Advised Via Telephone",
        "Not Advisied"
      ],
      "multi": ",",
      "prompt": "What type of advising did you receive this term? (check all that apply)"
    },
    {
      "renderer": "Multi",
      "i": 6,
      "code": "Q4",
      "prefix": "Q4",
      "n": 3,
      "part": null,
      "kind": "single",
      "choices": [
        "DegreeWorks Plan",
        "Courses for Upcoming Semester",
        "Alternate Courses for Upcoming Semester",
        "Campus Resources (Financial Aid, Counseling Center, Center for Academic Success, etc.)",
        "Choosing a Major/Minor",
        "Transfer Course Equivalencies",
        "Graduation Application Process",
        "Internships/Co-ops",
        "Study Abroad",
        "Personal Concerns (Family Issues, Health Issues, Work Schedule, etc.)",
        "Academic Standing",
        "Service-Learning and/or Campus Involvement",
        "Other, please specify:"
      ],
      "multi": ",",
      "prompt": "In my session, my advisor covered the following topics. (check all that apply)",
      "attachedComment": {
        "code": "Q4_13_TEXT",
        "prompt": "Other, please specify:"
      }
    },
    {
      "renderer": "Single",
      "i": 8,
      "code": "Q5",
      "prefix": "Q5",
      "n": 4,
      "part": null,
      "kind": "single",
      "choices": [
        "Never",
        "1-2",
        "3-4",
        "5 or more"
      ],
      "multi": false,
      "options": {
        "usePatterns": true,
        "continuous": true,
        "colors": [
          "#eeeeee",
          "#995555"
        ]
      },
      "prompt": "How often did you seek the assistance of an academic advisor in the past academic year?"
    },
    {
      "renderer": "Multi",
      "i": 9,
      "code": "Q6",
      "prefix": "Q6",
      "n": 5,
      "part": null,
      "kind": "single",
      "choices": [
        "I read material on courseleaf.ua.edu (catalog).",
        "I read material provided by my department/college.",
        "I created or reviewed a DegreeWorks plan.",
        "I came up with a list of proposed courses for the upcoming semester.",
        "I developed a list of questions for my advisor.",
        "I did not prepare."
      ],
      "multi": ",",
      "prompt": "How did you prepare for your advising session? (check all that apply)"
    },
    {
      "renderer": "Matrix",
      "i": 10,
      "code": "Q7_1",
      "prefix": "Q7",
      "n": 6,
      "part": 1,
      "kind": "group",
      "prompt": "Use the scale below to rate your advising experience in the following areas.",
      "choices": [
        "Very satisfied",
        "Satisfied",
        "No opinion",
        "Unsatisfied",
        "Very unsatisfied"
      ],
      "items": [
        "Advisor's knowledge of major requirements",
        "Advisor's knowledge of core requirements",
        "Overall satisfaction with advising session",
        "Satisfaction with length of advising session"
      ]
    },
    {
      "renderer": "Single",
      "i": 14,
      "code": "Q8",
      "prefix": "Q8",
      "n": 7,
      "part": null,
      "kind": "single",
      "choices": [
        "Strongly agree",
        "Agree",
        "Disagree",
        "Strongly disagree",
        "Not applicable"
      ],
      "multi": false,
      "prompt": "During my advising appointment, all of my questions were answered.  "
    },
    {
      "renderer": "Single",
      "i": 15,
      "code": "Q9",
      "prefix": "Q9",
      "n": 8,
      "part": null,
      "kind": "single",
      "choices": [
        "Strongly agree",
        "Agree",
        "Disagree",
        "Strongly disagree",
        "Not applicable"
      ],
      "multi": false,
      "prompt": "During my advising session, I felt comfortable talking to my advisor.  "
    },
    {
      "renderer": "Comment",
      "i": 16,
      "code": "Q10",
      "prefix": "Q10",
      "n": 9,
      "part": null,
      "prompt": "If you indicated in question 9 that you felt uncomfortable talking with your advisor, what could have been done to make you more comfortable?",
      "kind": "comment",
      "multi": false
    },
    {
      "renderer": "Single",
      "i": 17,
      "code": "Q11",
      "prefix": "Q11",
      "n": 10,
      "part": null,
      "kind": "single",
      "choices": [
        "Very likely",
        "Somewhat likely",
        "Not likely"
      ],
      "multi": false,
      "prompt": "How likely are you to recommend your advisor to another student?"
    },
    {
      "renderer": "Multi",
      "i": 18,
      "code": "Q12",
      "prefix": "Q12",
      "n": 11,
      "part": null,
      "kind": "single",
      "choices": [
        "In-person Advising Session",
        "Group Advising",
        "Advising Via Email",
        "Advising Via Telephone",
        "Walk-in Advising"
      ],
      "multi": ",",
      "prompt": "What type of advising session would you prefer?"
    },
    {
      "renderer": "Multi",
      "i": 19,
      "code": "Q13",
      "prefix": "Q13",
      "n": 12,
      "part": null,
      "kind": "single",
      "choices": [
        "Advisor and student communication",
        "Timeframe for scheduling an appointment",
        "Organization of the process",
        "Other, please explain."
      ],
      "multi": ",",
      "prompt": "What would you like to see improved?  (check all that apply)",
      "attachedComment": {
        "code": "Q13_4_TEXT",
        "prompt": "Other, please explain."
      }
    },
    {
      "renderer": "Comment",
      "i": 21,
      "code": "Q14",
      "prefix": "Q14",
      "n": 13,
      "part": null,
      "prompt": "What overall suggestion or thoughts do you have that would improve advising within your college?",
      "kind": "comment",
      "multi": false
    }
  ],
  "solicited": 25667
}
const Wrapper = pageProps => <Page {...pageProps} {...props} />
export const query = graphql`query {
    retabulateRoot {
      tabulations {
        ...Q1202010Fragment ...Q2202010Fragment ...Q3202010Fragment ...Q4202010Fragment ...Q5202010Fragment ...Q6202010Fragment ...Q7202010Fragment ...Q8202010Fragment ...Q9202010Fragment ...Q11202010Fragment ...Q12202010Fragment ...Q13202010Fragment 
      }
    }
    survey: allAdvising202010Csv {
      totalCount
    }
  }
  fragment Q1202010Fragment on tabulations {
  Q1202010: table(set: "Advising202010Csv", where: [{key: "Q1", values: ["College of Arts & Sciences", "Culverhouse College of Commerce", "College of Communication & Information Sciences", "College of Education", "College of Engineering", "College of Human Environmental Sciences", "Capstone College of Nursing", "School of Social Work", "Capstone Center for Student Success", "I don't know"]}]) {
    left {
      _skip_0: classes(key: "Q1", mapping: [{label: "College of Arts & Sciences", values: ["College of Arts & Sciences"]}, {label: "Culverhouse College of Commerce", values: ["Culverhouse College of Commerce"]}, {label: "College of Communication & Information Sciences", values: ["College of Communication & Information Sciences"]}, {label: "College of Education", values: ["College of Education"]}, {label: "College of Engineering", values: ["College of Engineering"]}, {label: "College of Human Environmental Sciences", values: ["College of Human Environmental Sciences"]}, {label: "Capstone College of Nursing", values: ["Capstone College of Nursing"]}, {label: "School of Social Work", values: ["School of Social Work"]}, {label: "Capstone Center for Student Success", values: ["Capstone Center for Student Success"]}, {label: "I don't know", values: ["I don't know"]}], renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
      _skip_1: all(label: "Total", renderId: "r2") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "RecipientEmail", renderId: "r3") {
        renderId
        renderIds
        _r4: statistic(method: "n", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r5: statistic(method: "pctn", over: "Q1", renderId: "r5") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q2202010Fragment on tabulations {
  Q2202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: classes(key: "Q2", mapping: [{label: "Office of University Registrar", values: ["Office of University Registrar"]}, {label: "Family Member", values: ["Family Member"]}, {label: "Athletic Advisor", values: ["Athletic Advisor"]}, {label: "DegreeWorks", values: ["DegreeWorks"]}, {label: "Academic Advisor", values: ["Academic Advisor"]}, {label: "Undergraduate Catalog (Web)", values: ["Undergraduate Catalog (Web)"]}, {label: "Other Students", values: ["Other Students"]}], orderByStatistic: {column: "RecipientEmail", method: "n", descending: true}, delimiter: ",", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q2", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "n", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r4: statistic(method: "pctn", over: "Q2", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q3202010Fragment on tabulations {
  Q3202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: classes(key: "Q3", mapping: [{label: "In-person Advising Appointment", values: ["In-person Advising Appointment"]}, {label: "Referred to DegreeWorks Worksheet or Plan", values: ["Referred to DegreeWorks Worksheet or Plan"]}, {label: "Group Session", values: ["Group Session"]}, {label: "Advised Via Email", values: ["Advised Via Email"]}, {label: "Advised Via Telephone", values: ["Advised Via Telephone"]}, {label: "Not Advisied", values: ["Not Advisied"]}], orderByStatistic: {column: "RecipientEmail", method: "n", descending: true}, delimiter: ",", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q3", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "n", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r4: statistic(method: "pctn", over: "Q3", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q4202010Fragment on tabulations {
  Q4202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: classes(key: "Q4", mapping: [{label: "DegreeWorks Plan", values: ["DegreeWorks Plan"]}, {label: "Courses for Upcoming Semester", values: ["Courses for Upcoming Semester"]}, {label: "Alternate Courses for Upcoming Semester", values: ["Alternate Courses for Upcoming Semester"]}, {label: "Campus Resources (Financial Aid, Counseling Center, Center for Academic Success, etc.)", values: ["Campus Resources (Financial Aid/ Counseling Center/ Center for Academic Success/ etc.)"]}, {label: "Choosing a Major/Minor", values: ["Choosing a Major/Minor"]}, {label: "Transfer Course Equivalencies", values: ["Transfer Course Equivalencies"]}, {label: "Graduation Application Process", values: ["Graduation Application Process"]}, {label: "Internships/Co-ops", values: ["Internships/Co-ops"]}, {label: "Study Abroad", values: ["Study Abroad"]}, {label: "Personal Concerns (Family Issues, Health Issues, Work Schedule, etc.)", values: ["Personal Concerns (Family Issues/ Health Issues/ Work Schedule/ etc.)"]}, {label: "Academic Standing", values: ["Academic Standing"]}, {label: "Service-Learning and/or Campus Involvement", values: ["Service-Learning and/or Campus Involvement"]}, {label: "Other, please specify:", values: ["Other/ please specify:"]}], orderByStatistic: {column: "RecipientEmail", method: "n", descending: true}, delimiter: ",", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q4", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "n", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r4: statistic(method: "pctn", over: "Q4", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q5202010Fragment on tabulations {
  Q5202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: all(label: "How often did you seek the assistance of an academic advisor in the past academic year?", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q5", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "distributionRatio", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q6202010Fragment on tabulations {
  Q6202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: classes(key: "Q6", mapping: [{label: "I read material on courseleaf.ua.edu (catalog).", values: ["I read material on courseleaf.ua.edu (catalog)."]}, {label: "I read material provided by my department/college.", values: ["I read material provided by my department/college."]}, {label: "I created or reviewed a DegreeWorks plan.", values: ["I created or reviewed a DegreeWorks plan."]}, {label: "I came up with a list of proposed courses for the upcoming semester.", values: ["I came up with a list of proposed courses for the upcoming semester."]}, {label: "I developed a list of questions for my advisor.", values: ["I developed a list of questions for my advisor."]}, {label: "I did not prepare.", values: ["I did not prepare."]}], orderByStatistic: {column: "RecipientEmail", method: "n", descending: true}, delimiter: ",", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q6", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "n", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r4: statistic(method: "pctn", over: "Q6", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q7202010Fragment on tabulations {
  Q7202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: transpose(keys: ["Q7_1", "Q7_2", "Q7_3", "Q7_4"], asKey: "q", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "q", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "distributionRatio", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q8202010Fragment on tabulations {
  Q8202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: all(label: "During my advising appointment, all of my questions were answered.  ", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q8", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "distributionRatio", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q9202010Fragment on tabulations {
  Q9202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: all(label: "During my advising session, I felt comfortable talking to my advisor.  ", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q9", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "distributionRatio", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q11202010Fragment on tabulations {
  Q11202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: all(label: "How likely are you to recommend your advisor to another student?", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q11", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "distributionRatio", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q12202010Fragment on tabulations {
  Q12202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: classes(key: "Q12", mapping: [{label: "In-person Advising Session", values: ["In-person Advising Session"]}, {label: "Group Advising", values: ["Group Advising"]}, {label: "Advising Via Email", values: ["Advising Via Email"]}, {label: "Advising Via Telephone", values: ["Advising Via Telephone"]}, {label: "Walk-in Advising", values: ["Walk-in Advising"]}], orderByStatistic: {column: "RecipientEmail", method: "n", descending: true}, delimiter: ",", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q12", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "n", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r4: statistic(method: "pctn", over: "Q12", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}

fragment Q13202010Fragment on tabulations {
  Q13202010: table(set: "Advising202010Csv") {
    left {
      _skip_0: classes(key: "Q13", mapping: [{label: "Advisor and student communication", values: ["Advisor and student communication"]}, {label: "Timeframe for scheduling an appointment", values: ["Timeframe for scheduling an appointment"]}, {label: "Organization of the process", values: ["Organization of the process"]}, {label: "Other, please explain.", values: ["Other/ please explain."]}], orderByStatistic: {column: "RecipientEmail", method: "n", descending: true}, delimiter: ",", renderId: "r1") {
        renderId
        renderIds
        label
        node {
          leaf
        }
      }
    }
    top {
      _skip_0: variable(key: "Q13", renderId: "r2") {
        renderId
        renderIds
        _r3: statistic(method: "n", renderId: "r3") {
          renderId
          renderIds
          node {
            leaf
          }
        }
        _r4: statistic(method: "pctn", over: "Q13", renderId: "r4") {
          renderId
          renderIds
          node {
            leaf
          }
        }
      }
    }
    rows {
      cells {
        value
        colID
        rowID
        variable
        detransposed
        agg
        renderIds
        redacted
        queries {
          key
          values
        }
      }
    }
  }
}


  `
export default Wrapper
